module.exports = {
  DRIVING: 'driving',
  HALTED: 'halted',
  IDLING: 'idling',
  PARKED: 'parked',
  STARTING: 'starting',
  TOWED_AWAY: 'towed-away',
};
